var SendMessage=(LaboratoryNo,Name,Phone)=>axios._get(`/api/User/SendMessageIdFolic?LaboratoryNo=${LaboratoryNo}&Name=${Name}&Phone=${Phone}`);//发送验证码

var Login=(LaboratoryNo,Name,Phone,verify)=>axios._get(`/api/User/LoginByUserPhoneAndLaboratoryNo?LaboratoryNo=${LaboratoryNo}&Name=${Name}&Phone=${Phone}&verify=${verify}`);//登录
var SendMessagesVoice=(LaboratoryNo,Name,Phone)=>axios.get(`/api/User/SendAudioMessageIdFolic?LaboratoryNo=${LaboratoryNo}&Name=${Name}&Phone=${Phone}`);//語音發送驗證碼

var LoginsImg=(LaboratoryNo,Name,Phone,verify)=>axios._get(`/api/User/LoginUrlByUserPhoneAndLaboratoryNoImgFolic?LaboratoryNo=${LaboratoryNo}&Name=${Name}&Phone=${Phone}&verify=${verify}`);

var Logins=(Id,Name,Phone,verify)=>axios._get(`/api/User/LoginUrlByUserPhoneAndLaboratoryNo?Id=${Id}&Name=${Name}&Phone=${Phone}&verify=${verify}`);

export{
    SendMessage,
    Login,
    SendMessagesVoice,
    Logins,    
    LoginsImg,
}



// WEBPACK FOOTER //
// ./src/service/searchreportfolic.js